import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GridObject } from 'src/app/structure/model/grid-view';
import { ResponseApi } from 'src/app/structure/model/response-api';
import { ApiService } from 'src/app/structure/service/api.service';

import { Modulo } from '../manutencao/modulo/models/modulo';
import { ModuloService } from '../manutencao/modulo/modulo.service';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(
      private moduloService: ModuloService,
      private api: ApiService,) { }

}

